module.exports = __webpack_public_path__ + "img/hero-water-02.626ba513.png";